import React from "react";

const Footer = () => {
  return <section id="footer"></section>;
};

export default Footer;
